import { memo, useCallback } from 'react';
import cn from 'classnames';
import { Checkbox, Element } from 'src/components';

const REPORT_CONTENT_OPTIONS = [
    'Bạo lực',
    'Đồi truỵ',
    'Phản cảm',
    'Xuyên tạc',
    'Kỳ thị địa phương',
];

export default memo(function SelectContent({ contents, setContent }: any) {
    const handleCheck = useCallback(
        (value: any) => (e: any) => {
            let list = [...contents];
            if (e.target.checked) {
                list.push(value);
            } else {
                list = list.filter((item) => item !== value);
            }
            setContent(list);
        },
        [contents]
    );

    return (
        <Element className={cn('flex flex-wrap', 'ml-[-24px]]')}>
            {REPORT_CONTENT_OPTIONS.map((item) => (
                <Checkbox
                    className="relative"
                    classNameCheckbox={cn('peer/report', 'absolute opacity-0')}
                    classNameLabel={cn(
                        'inline-block',
                        'text-[1.4rem] text-[#777]',
                        'px-[20px] py-[5px] m-[4px]',
                        'rounded-[3px]',
                        'bg-white',
                        'border border-solid border-[#ddd]',
                        'peer-checked/report:bg-[var(--danger)]',
                        'peer-checked/report:border-[var(--danger)]',
                        'peer-checked/report:text-white'
                    )}
                    onChange={handleCheck(item)}
                    key={item}
                >
                    {item}
                </Checkbox>
            ))}
        </Element>
    );
});
